export default "__VITE_ASSET__NZ6e_aZz__"